import useAppSelector from '@fogia/core-web/hooks/useAppSelector';
import CmsModules from '@fogia/core-web/libs/sanity/content/CmsModules';
import Breadcrumbs from 'components/Breadcrumbs';
import React from 'react';
import { shallowEqual } from 'react-redux';

const Page = () => {
    // const heroContent = useAppSelector(({ page }) => page?.data?.heroContent, shallowEqual);
    const pageContent = useAppSelector(({ page }) => page?.data?.pageContent, shallowEqual);

    return (
        <>
            <Breadcrumbs />
            {/* {heroContent && <CmsModules isHero data={heroContent} />} */}
            {pageContent && <CmsModules data={pageContent} eagerImageModuleCount={2} />}
        </>
    );
};

export default Page;
